module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changePassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPsw),
      expression: "newPsw"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "password",
      "name": "newPsw",
      "id": "newPsw",
      "placeholder": "Nueva clave",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPsw = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPswRe),
      expression: "newPswRe"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "password",
      "name": "newPswRe",
      "id": "newPswRe",
      "placeholder": "Repetir clave",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPswRe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPswRe = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Finalizar registro")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 form-label"
  }, [_c('label', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "for": "newPsw"
    }
  }, [_vm._v("Nueva clave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 form-label"
  }, [_c('label', {
    attrs: {
      "for": "newPswRe"
    }
  }, [_vm._v("Repetir clave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3526af79"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/FinSolicitud.vue
// module id = 621
// module chunks = 1